<script setup lang="ts">
defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    errors: string[]
}>();
</script>

<template>
    <div
        role="alert"
        data-slot="form-field-errors"
        class="text-sm text-destructive"
    >
        <template v-if="props.errors.length === 1">
            {{ props.errors[0] }}
        </template>
        <ul
            v-else
            class="ml-4 flex list-disc flex-col gap-1"
        >
            <li
                v-for="error in props.errors"
                :key="error"
            >
                {{ error }}
            </li>
        </ul>
    </div>
</template>
